(ns frontend.page-components.default-page-layout
  (:require
   [frontend.ux-overhaul.page-components.page-layout :as new-navigation]))

(defn view
  ([child-view] (view nil child-view))
  ([{:keys [class-name metabase?] :as opts} child-view]
   [new-navigation/new-navigation-layout opts child-view]))
